/**
 * 一般模式 IG 留言回覆畫布的節點是否可拖曳。
 * WHY：檢視者拖了不會存（updateFlowChart 對 isViewer 早退）、啟用中規則與 drawer 一樣鎖編輯，
 * 兩者都不開拖曳，避免畫面動了資料沒動的錯覺；其餘沿用畫布本身的 isFlowDraggable（float panel hover 會暫時關閉）。
 */
export const resolveCommentReplyNodesDraggable = ({
  isFlowDraggable,
  isViewer,
  isActive,
}: {
  isFlowDraggable: boolean;
  isViewer: boolean;
  isActive?: boolean;
}): boolean => isFlowDraggable && !isViewer && !isActive;
